/* Pro-page placement only. Impact continues to handle every add-to-cart action. */
(() => {
  if (!document.body.classList.contains('ac-pro-page')) return;
  // Preserve the Pro journey when Shopify changes markets; each market has its own product.
  document.addEventListener('submit', event => {
    const button = event.submitter;
    if (!button?.dataset.acProTarget || button.name !== 'country_code') return;
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    let destination = form.querySelector('input[name="return_to"]');
    if (!destination) {
      destination = document.createElement('input');
      destination.type = 'hidden'; destination.name = 'return_to'; form.append(destination);
    }
    destination.value = button.dataset.acProTarget;
  }, true);
  let scheduled = false;
  const update = () => {
    scheduled = false;
    const purchase = document.querySelector('.shopify-section--main-product .product-info__buy-buttons');
    if (!purchase) return;
    const rect = purchase.getBoundingClientRect();
    const useMobileScrollTrigger = matchMedia('(max-width:699px)').matches;
    let stickyClearance = 0;
    document.querySelectorAll('product-quick-add').forEach(bar => {
      const shouldHide = useMobileScrollTrigger ? scrollY <= 16 : rect.bottom > 0;
      if (bar.hidden !== shouldHide) bar.hidden = shouldHide;
      if (!shouldHide && bar.classList.contains('is-visible')) stickyClearance = Math.max(stickyClearance,
        bar.getBoundingClientRect().height + (parseFloat(getComputedStyle(bar).bottom) || 0) + 16);
    });
    document.body.style.setProperty('--ac-pro-sticky-clearance', `${Math.ceil(stickyClearance)}px`);
    // Leave room for a closed chat launcher when the main purchase button is near the viewport bottom.
    const launcher = document.querySelector('.BeaconFabButtonFrame');
    const launcherWidth = launcher?.getBoundingClientRect().width || 60;
    const inLauncherBand = rect.bottom > innerHeight - 40 - launcherWidth && rect.top < innerHeight - 40;
    const clearance = inLauncherBand ? Math.max(40, innerHeight - rect.top + 16) : 40;
    document.body.style.setProperty('--ac-pro-main-buy-clearance', `${Math.ceil(clearance)}px`);
  };
  const schedule = () => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
  };
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', schedule);
  const observer = new ResizeObserver(schedule);
  const product = document.querySelector('.shopify-section--main-product');
  if (product) observer.observe(product);
  update();
})();

/* In-page navigation: native anchors remain usable without JavaScript. */
(() => {
  if (!document.body.classList.contains('ac-pro-page')) return;
  let cleanup = () => {};
  const init = () => {
    cleanup();
    const nav = document.querySelector('.ac-pro-section-nav');
    if (!nav) return;
    const wrapper = nav.closest('.shopify-section');
    const scroller = nav.querySelector('.ac-pro-section-nav__links');
    const links = [...nav.querySelectorAll('a[href^="#"]')];
    const targets = links.map(link => document.getElementById(link.hash.slice(1)));
    const controller = new AbortController();
    let frame = 0, active = null;
    const measure = () => {
      frame = 0;
      let top = 0;
      document.querySelectorAll('.shopify-section--header,.shopify-section--announcement-bar').forEach(header => {
        const position = getComputedStyle(header).position;
        const rect = header.getBoundingClientRect();
        if ((position === 'sticky' || position === 'fixed') && rect.top <= top + 1 && rect.bottom > 0) top = Math.max(top,rect.bottom);
      });
      document.body.style.setProperty('--ac-pro-nav-top',`${Math.round(top)}px`);
      document.body.style.setProperty('--ac-pro-nav-height',`${nav.offsetHeight}px`);
      const threshold = top + nav.offsetHeight + 40;
      let current = null;
      targets.forEach((target,index) => { if (target && target.getBoundingClientRect().top <= threshold) current = links[index]; });
      if (wrapper.getBoundingClientRect().top > top + 1) current = null;
      if (active !== current) {
        links.forEach(link => { if (link === current) link.setAttribute('aria-current','location'); else link.removeAttribute('aria-current'); });
        active = current;
        if (current && scroller.scrollWidth > scroller.clientWidth) {
          scroller.scrollTo({left:current.offsetLeft - scroller.offsetLeft - (scroller.clientWidth-current.offsetWidth)/2,behavior:'instant'});
        }
      }
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(measure); };
    addEventListener('scroll',schedule,{passive:true,signal:controller.signal});
    addEventListener('resize',schedule,{passive:true,signal:controller.signal});
    addEventListener('pageshow',schedule,{signal:controller.signal});
    nav.addEventListener('click',event => {
      const link = event.target.closest('a[href^="#"]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      measure();
      history.pushState(null,'',link.hash);
      const offset = parseFloat(document.body.style.getPropertyValue('--ac-pro-nav-top')) + nav.offsetHeight + 20;
      window.scrollTo({top:window.scrollY + target.getBoundingClientRect().top - offset,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      target.setAttribute('tabindex','-1');
      target.focus({preventScroll:true});
    },{signal:controller.signal});
    const resize = new ResizeObserver(schedule);
    resize.observe(nav);
    document.querySelectorAll('.shopify-section--header,.shopify-section--announcement-bar').forEach(el => resize.observe(el));
    measure();
    cleanup = () => { controller.abort(); resize.disconnect(); cancelAnimationFrame(frame); };
  };
  init();
  document.addEventListener('shopify:section:load',init);
})();
